import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../../core/table/table.component';
import { ColumnComponent } from '../../../core/table/column.component';
import {
  LoadingPanelComponent,
  LoadingState,
} from '../../../core/panels/loading-panel.component';
import { BaseComponent } from '../../../base/base.component';
import { getClaimKey } from '../../../../functions/get-claim-key';
import { CasePipe } from '../../../../pipes/case.pipe';

@Component({
  selector: 'app-reserves-expense-tab',
  imports: [
    CommonModule,
    TableComponent,
    ColumnComponent,
    LoadingPanelComponent,
    CasePipe,
  ],
  template: `
    <app-loading-panel
      [state]="loadingState"
      loadingStyle="Skeleton"
      [loadingHeight]="215"
    >
      <ng-template #loaded>
        <app-table
          class="highlightable-table"
          [dataSource]="expenses"
          [scrollable]="false"
          [expandable]="false"
          dataKey="sequenceNum"
          recordLabel="Item"
          [showPaginator]="false"
          [stripedRows]="true"
          [showFilter]="false"
          [showFilterButton]="false"
          [theme]="'Dark'"
        >
          <app-column name="categoryDesc" label="Category" [sort]="false">
            <ng-template let-row>
              @if (row.categoryDesc === 'Total Expense') {
                <span class="highlight-row">
                  {{ row.categoryDesc | case: 'sentence' }}
                </span>
              } @else {
                {{ row.categoryDesc | case: 'sentence' }}
              }
            </ng-template>
          </app-column>
          <app-column name="paid" label="Paid" format="c" [sort]="false" />
          <app-column
            name="scheduled"
            label="Scheduled"
            format="c"
            [sort]="false"
          />
          <app-column
            name="reserve"
            label="Reserve"
            format="c"
            [sort]="false"
          />
          <app-column
            name="incurred"
            label="Incurred"
            format="c"
            [sort]="false"
          />
          <app-column
            name="preInjuryAww"
            label="Pre-Injury AWW"
            format="c"
            [sort]="false"
          />
        </app-table>
      </ng-template>
    </app-loading-panel>
  `,
  styles: ``,
})
export class ReservesExpenseTabComponent
  extends BaseComponent
  implements OnInit
{
  @Input()
  reserveNumber = 0;

  expenses: any[] = [];
  loadingState: LoadingState = 'Init';
  private loaded = false;

  async ngOnInit() {
    if (this.loaded) return;

    this.loadingState = 'Loading';
    try {
      this.expenses = await this.api.reserves.getExpense(
        getClaimKey(),
        this.reserveNumber,
      );
      this.loaded = true;
    } finally {
      this.loadingState = 'Loaded';
    }
  }
}
